import { __assign, __extends } from "tslib";
import React from 'react';
import BaseViewer from './Base';
import omit from 'lodash/omit';
import mergeTheme from '../Themes/mergeTheme';
import baseTheme from '../Themes/Viewer/poll.scss';
var PollAnswerViewer = /** @class */ (function (_super) {
    __extends(PollAnswerViewer, _super);
    function PollAnswerViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.theme = mergeTheme(baseTheme, _this.props.theme);
        return _this;
    }
    PollAnswerViewer.prototype.render = function () {
        var restProps = omit(this.props, ['theme']);
        return (React.createElement("div", { className: 'da-editor-poll' },
            React.createElement(BaseViewer, __assign({ theme: this.theme }, restProps, { fixedParagraph: false }))));
    };
    return PollAnswerViewer;
}(React.Component));
export default PollAnswerViewer;
//# sourceMappingURL=PollAnswer.js.map